<template>
    <AdminAccountList :pk="'CAL-'" :lockedFilters="lockedFilters" :hidePartnerCompanyFilter="true"
        :hideCustomerFilter="!!customerId" :hideDepartmentFilter="true" :hideUserTypeFilter="false"
        :userTypeFilterOptions="userTypeFilterOptions">
    </AdminAccountList>
</template>


<script>
import AdminAccountList from '@/views/admin/accounts/AdminAccountList.vue';

export default {
    name: "CustomerAccountList",
    props: {},
    components: {
        AdminAccountList,
    },

    data() {
        return {};
    },

    mounted() { },

    methods: {},

    computed: {
        customerId() {
            return this.$route.params.customerId;
        },
        lockedFilters() {
            var filters = {
                UserTypeIdList: [4, 6],
            };
            if (this.customerId) {
                filters.CustomerIdList = [this.customerId];
            }
            return filters;
        },
        userTypeFilterOptions() {
            return [4, 6];
        },
    },

    watch: {},
};
</script>


<style lang='scss'></style>